import React from "react";
import { translate } from "react-i18next";
import groupImg from "../../assets/media/revised/grouphhh.png";
import applicationImg from "../../assets/media/revised/daycash_application_logo.png";
import partnerImg from "../../assets/media/revised/daycash_partnersite_logo.png";

function Help({ t }) {
	return (
		<div>
			<section>
				<div className="container">
					<h1 className="main-title text-center ">{t("help_title")}</h1>
					<div className="row" style={{ padding: "2rem 0" }}>
						<div className="col-md-4">
							<div>
								<img
									className="center-img"
									src={applicationImg}
									alt="application logo"
								/>
								<span className="text-in-img">{t("pic_employee")}</span>
							</div>
						</div>
						<div className="col-md-4">
							<img className="center-img" src={groupImg} alt="group img" />
						</div>
						<div className="col-md-4">
							<div>
								<img
									className="center-img"
									src={partnerImg}
									alt="application logo"
								/>
								<span className="text-in-img">{t("pic_employer")}</span>
							</div>
						</div>
					</div>
					<div className="row" style={{ marginTop: "3rem" }}>
						<div className="col-xs-12">
							<h2 className="gradient-txt">{t("help_cashflow_title")}</h2>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">{t("help_topic_title1")}</h3>
								<p>{t("help_topic_desc1")}</p>
								<p>{t("help_topic_desc1_1")}</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">{t("help_topic_title2")}</h3>
								<p>{t("help_topic_desc2")}</p>
							</div>
							<div className="topic-wrapper">
								<h3 className="help-topic-title">{t("help_topic_title3")}</h3>
								<p>{t("help_topic_desc3")}</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">{t("help_topic_title4")}</h3>
								<p>{t("help_topic_desc4")}</p>
							</div>
							<div className="topic-wrapper">
								<h3 className="help-topic-title">{t("help_topic_title5")}</h3>
								<p>{t("help_topic_desc5")}</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default translate("translations")(Help);



// WEBPACK FOOTER //
// ./src/components/home/Help.jsx